import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommunityLink, CommunityGroupUser } from '../../interfaces';
import { ConfigurationService } from '../util/configuration.service';
import { CommunityLinksStrategy } from './community-links-strategy.interface';

@Injectable({ providedIn: 'root' })
export class GroupLinksStrategy implements CommunityLinksStrategy {
  private configurationService = inject(ConfigurationService);

  loadLinks(groupId: string): Observable<CommunityLink[]> {
    return this.configurationService.getCachedGroupUsers(groupId).pipe(
      map(items =>
        items.map((link: CommunityGroupUser) => ({
          title: link.username,
          link: `/profile/${link.username}`,
          icon_link: link.avatar_url,
        }))
      )
    );
  }
}
